<script setup lang="ts">
import RegistrationStages from '~/pages/registration/components/registration-stages.vue';
import { getRewardfulScripts } from '#imports';
import { useHead } from '#app';

useHead({
  title: 'Registration | WeEngrave',
  script: [
    ...getRewardfulScripts(),
  ],
});
</script>

<template>
  <div class="container mx-auto min-h-100vh flex justify-center items-center overflow-auto py-12.5 lg:py-28">
    <RegistrationStages />
  </div>
</template>
